import { Component, inject } from '@angular/core';
import { MouldingGraphService } from '../services/moulding-graph.service';
import { MouldingNodeDialogService } from '../services/moulding-node-dialog.service';
import {
  isProcessingNodeKind,
  ProcessingNodeKind,
} from '../nodes/moulding-node-registry';
import { CadInputNodeConfigDialogComponent } from '../nodes/cad-input-node-config-dialog/cad-input-node-config-dialog.component';
import { CadInputPickerDialogComponent } from '../nodes/cad-input-picker-dialog/cad-input-picker-dialog.component';
import { DfmCheckNodeConfigDialogComponent } from '../nodes/dfm-check-node-config-dialog/dfm-check-node-config-dialog.component';
import { PullDirectionNodeConfigDialogComponent } from '../nodes/pull-direction-node-config-dialog/pull-direction-node-config-dialog.component';
import { ProcessingStepNodeConfigDialogComponent } from '../nodes/processing-step-node-config-dialog/processing-step-node-config-dialog.component';

type GeometryProcessingNodeKind = Exclude<ProcessingNodeKind, 'dfm_check'>;

@Component({
  selector: 'app-moulding-node-dialog-host',
  standalone: true,
  imports: [
    CadInputNodeConfigDialogComponent,
    CadInputPickerDialogComponent,
    DfmCheckNodeConfigDialogComponent,
    PullDirectionNodeConfigDialogComponent,
    ProcessingStepNodeConfigDialogComponent,
  ],
  templateUrl: './moulding-node-dialog-host.component.html',
})
export class MouldingNodeDialogHostComponent {
  private readonly graph = inject(MouldingGraphService);
  readonly dialogs = inject(MouldingNodeDialogService);

  hasCadInputSelection(nodeId: string): boolean {
    return (
      this.graph.getNodeData(nodeId, 'cad_input')?.result?.artifact !==
      undefined
    );
  }

  isGeometryProcessingNodeKind(
    nodeKind: string,
  ): nodeKind is GeometryProcessingNodeKind {
    return nodeKind !== 'dfm_check' && isProcessingNodeKind(nodeKind);
  }

  onVisibleChange(visible: boolean): void {
    if (!visible) {
      this.dialogs.close();
    }
  }
}
